interface TransactionSkeletonProps {
    type?: string
}
export function TransactionItemMobileSkeleton({
    type = 'bank',
}: TransactionSkeletonProps) {
    const Bank = (
        <tr className='flex flex-row items-center justify-between w-full border-b border-solid border-skeleton border-opacity-10 animate-pulse'>
            <td className={''}>
                <div className='flex flex-row items-center overflow-visible text-left break-words truncate'>
                    <div className='w-6 h-6 rounded-full bg-skeleton'></div>
                    <div className='flex flex-col gap-2'>
                        <div className='w-48 h-4 ml-2 rounded bg-skeleton'></div>
                        <div className='w-24 h-4 ml-2 rounded bg-skeleton'></div>
                    </div>
                </div>
            </td>
            <td className='py-6 '>
                <div className='w-16 h-4 rounded bg-skeleton'></div>
            </td>
        </tr>
    )
    const Crypto = (
        <tr className='border-b border-solid border-skeleton border-opacity-10 animate-pulse'>
            <td className={'pr-8'}>
                <div className='w-6 h-6 rounded-full bg-skeleton'></div>
            </td>
            <td className='py-5'>
                <div className='w-24 h-4 rounded bg-skeleton'></div>
            </td>
            <td>
                <div className='w-24 h-4 rounded bg-skeleton'></div>
            </td>
            <td>
                <div className='w-12 h-4 rounded bg-skeleton'></div>
            </td>
            <td className={''}>
                <div className='flex flex-row items-center justify-end w-full'>
                    <div className='w-24 h-4 rounded bg-skeleton'></div>
                </div>
            </td>
            <td className={''}>
                <div className='flex flex-row items-center justify-end w-full'>
                    <div className='w-24 h-4 rounded bg-skeleton'></div>
                </div>
            </td>
        </tr>
    )

    return type === 'bank' ? Bank : Crypto
}
